export const tag = ({ theme: { colors } }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: '14px',
    fontSize: '14px',
    padding: '.2em 1em',
});
